var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stockwarehouse',{attrs:{"warehouses":_vm.warehouses,"locationnetworks":_vm.locationNetworks,"locationnodes":_vm.locationNodes,"tableloading":_vm.tableLoading},on:{"warehouseChange":function($event){return _vm.getWarehouses()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }